import React from 'react';
import { Container, Menu, Segment, Image, Header } from 'semantic-ui-react';
import SoundDemoPanel from './SoundDemoPanel';
import Baby from './undraw_baby_ja7a.svg';
import Dog from './undraw_Cautious_dog_q83f.svg';
import Keyboard from './undraw_programmer_imem.svg';
import Children from './undraw_children_4rtb.svg';
import Construction from './undraw_under_construction_46pa.svg'
import Fan from './undraw_Server_re_twwj.svg'
import "./SoundDemoPanel.css"

class SoundDemoPanelCollection extends React.Component {
    state = { activeItem: 'keyboard' }
    handleItemClick = (e, { name }) =>  {
        this.setState({ activeItem: name })
    }
    
    render() {
        const { activeItem } = this.state

        var demoPanel = null
        if (activeItem === 'keyboard') {
            demoPanel = <SoundDemoPanel originalUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/keyboard_noisy.mp3'}
                                        noiseUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/keyboard_clean.mp3'}
                                        panelID={'keyboard'} />
        } else if (activeItem === 'crying baby') {
            demoPanel = <SoundDemoPanel originalUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/baby_noisy.mp3'}
                                        noiseUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/baby_clean.mp3'}
                                        panelID={'crying baby'} />
        } else if (activeItem === 'construction') {
            demoPanel = <SoundDemoPanel originalUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/construction_noisy.mp3'}
                                        noiseUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/construction_clean.mp3'}
                                        panelID={'construction'} />
        } else if (activeItem === 'computer fan') {
            demoPanel = <SoundDemoPanel originalUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/fan_noisy.mp3'}
                                        noiseUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/fan_clean.mp3'}
                                        panelID={'computer fan'} />
        }
        else if (activeItem == 'children') {
            demoPanel = <SoundDemoPanel originalUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/kids_noisy.mp3'}
                                        noiseUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/kids_clean.mp3'}
                                        panelID={'children'} />
        }else {
            demoPanel = <SoundDemoPanel originalUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/dog_noisy.mp3'}
                                        noiseUrl={'https://testsoundutterly.s3.us-east-2.amazonaws.com/dog_clean.mp3'} 
                                        panelID={'barking dog'}/>
        }
        var image = null
        if (activeItem === 'keyboard') {
            image = <Image centered size='large' style={{height: 300}} src={Keyboard} />;
        } else if (activeItem === 'crying baby') {
            image = <Image centered size='large' style={{height: 300}} src={Baby} />;
        } else if (activeItem === 'construction') {
            image = <Image centered size='large' style={{height: 300}} src={Construction} />;
        }
        else if (activeItem == "computer fan") {
            image = <Image centered size='large' style={{height: 300}} src={Fan} />;
        }
        else if (activeItem === 'children') {
            image = <Image centered size='large' style={{height: 300}} src={Children} />;
        } 
        else {
            image = <Image centered size='large' style={{height: 300}} src={Dog} />;
        }
        return <Container style={{marginTop: 50}}>
                <Segment>
                    {/* <Menu id="mobile-noise-demo-menu" attached='top' tabular widths={5}>
                        <Menu.Item
                            id='fonts'
                            name='keyboard'
                            active={activeItem === 'keyboard'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                        <Menu.Item
                            id='fonts'
                            name='barking dog'
                            active={activeItem === 'barking dog'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                        <Menu.Item
                            id='fonts'
                            name='construction'
                            active={activeItem === 'construction'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                        <Menu.Item
                            id='fonts'
                            name='computer fan'
                            active={activeItem === 'computer fan'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                    </Menu> */}
                    <Menu id="non-mobile-noise-demo-menu" attached='top' tabular widths={4}>
                        <Menu.Item
                            id='fonts'
                            name='keyboard'
                            active={activeItem === 'keyboard'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                        <Menu.Item
                            id='fonts'
                            name='barking dog'
                            active={activeItem === 'barking dog'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                        <Menu.Item
                            id='fonts'
                            name='construction'
                            active={activeItem === 'construction'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                        <Menu.Item
                            id='fonts'
                            name='computer fan'
                            active={activeItem === 'computer fan'}
                            onClick={this.handleItemClick}
                            className="noises-demo-menu-item"
                        />
                        {/* <Menu.Item
                            name='children'
                            active={activeItem === 'children'}
                            onClick={this.handleItemClick}
                        /> */}
                        {/* <Menu.Item
                            name='crying baby'
                            active={activeItem === 'crying baby'}
                            onClick={this.handleItemClick}
                        /> */}
                    </Menu>
                    <div style={{textAlign: 'center', marginTop: 40, marginBottom: 20}}>
                        {image}
                    </div>
                    <Header as='h3' id='fonts' style={{textAlign: 'center', marginTop: 40, marginBottom: 20}}>Remove Noise</Header>
                    {demoPanel}
                </Segment>
            </Container>
    }
}

export default SoundDemoPanelCollection;